import type {
  ProductOptionCreateInput,
  ProductOptionDTO,
  ProductOptionUpdateInput,
  ProductOptionValueDTO,
} from "@/modules/options/domain/contracts";
import type {
  OffsetPageDTO,
  OffsetPageQueryDTO,
} from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { ProductOptionDTO, ProductOptionValueDTO };

export type OptionsListQueryDTO = OffsetPageQueryDTO & {
  includeValues?: boolean;
};

export const productOptionsApi = {
  async list(
    query: OptionsListQueryDTO,
  ): Promise<OffsetPageDTO<ProductOptionDTO>> {
    const url = new URL(`${config.apiUrl}/catalog/options`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    if (query.includeValues === true)
      url.searchParams.set("includeValues", "true");
    return fetcher.get<OffsetPageDTO<ProductOptionDTO>>(url.toString());
  },

  async get(id: string): Promise<ProductOptionDTO> {
    return fetcher.get<ProductOptionDTO>(
      `${config.apiUrl}/catalog/options/${id}`,
    );
  },

  async create(input: ProductOptionCreateInput): Promise<ProductOptionDTO> {
    return fetcher.post<ProductOptionDTO>(
      `${config.apiUrl}/catalog/options`,
      input,
    );
  },

  async update(
    id: string,
    input: ProductOptionUpdateInput,
  ): Promise<ProductOptionDTO> {
    return fetcher.put<ProductOptionDTO>(
      `${config.apiUrl}/catalog/options/${id}`,
      input,
    );
  },

  async remove(id: string): Promise<{ ok: boolean }> {
    return fetcher.delete<{ ok: boolean }>(
      `${config.apiUrl}/catalog/options/${id}`,
    );
  },
};
